export default __webpack_public_path__ + "static/SaolDisplay-Regular-c8eb2c5e3fc8d35234a25a0c3115ef65.woff2";